import type { Status } from "../../../types/deal";
import type { DealsActiveFilter } from "../../userAllocations/userAllocationsApi";

/** Statuses selectable in the status filter for the given Active/Inactive/All scope. */
export function statusOptionsForDealsActive(
  allStatuses: Status[],
  dealsActive: DealsActiveFilter,
): Status[] {
  if (dealsActive === "active") {
    return allStatuses.filter((status) => status.is_active === true);
  }
  if (dealsActive === "inactive") {
    return allStatuses.filter((status) => status.is_active === false);
  }
  return allStatuses;
}

/**
 * Drop selected statuses that are not offered for the new scope, so switching
 * e.g. Active -> Inactive never sends active status ids with deals_active=false
 * (which returns nothing) or keeps a selection the dropdown can no longer show.
 */
export function pruneStatusFilter(
  selected: Status[],
  options: Status[],
): Status[] {
  const allowed = new Set(options.map((option) => option.id));
  const pruned = selected.filter((status) => allowed.has(status.id));
  return pruned.length === selected.length ? selected : pruned;
}
